import React from "react";
import { Button, IconButton } from "@mui/material";
import { FirstPage, LastPage, ChevronLeft, ChevronRight, MoreHoriz } from "@mui/icons-material";

export default function PaginationPageSelector({ page, total, limit, onChange, maxButtons = 5 }) {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;

  const pages = [];
  let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
  let endPage = startPage + maxButtons - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxButtons + 1);
  }

  if (startPage > 1) {
    pages.push(<Button key={1} onClick={() => onChange(1)}>1</Button>);
    if (startPage > 2) {
      pages.push(
        <Button key="start-ellipsis" disabled>
          <MoreHoriz />
        </Button>
      );
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <Button
        key={i}
        variant={i === page ? "contained" : "outlined"}
        onClick={() => onChange(i)}
      >
        {i}
      </Button>
    );
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(
        <Button key="end-ellipsis" disabled>
          <MoreHoriz />
        </Button>
      );
    }
    pages.push(
      <Button key={totalPages} onClick={() => onChange(totalPages)}>
        {totalPages}
      </Button>
    );
  }

  return (
    <div
      style={{
        flex: "0 0 auto",
        textAlign: "center",
        padding: "8px",
        borderTop: "1px solid #ddd",
        overflowX: "auto",
        whiteSpace: "nowrap",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 4,
      }}
    >
      <IconButton onClick={() => onChange(1)} disabled={page === 1}>
        <FirstPage />
      </IconButton>

      <IconButton onClick={() => onChange(page - 1)} disabled={page === 1}>
        <ChevronLeft />
      </IconButton>

      {pages}

      <IconButton onClick={() => onChange(page + 1)} disabled={page === totalPages}>
        <ChevronRight />
      </IconButton>

      <IconButton onClick={() => onChange(totalPages)} disabled={page === totalPages}>
        <LastPage />
      </IconButton>
    </div>
  );
}
